import { isObject, isUndefined, isEmpty, isBoolean, isNull, filter, get, keys, every, head, size } from 'lodash'

const getters = {
    getItems: state => params => {
        return isObject(params) && !isUndefined(params.nbItems) ? state.list.slice(0, parseInt(params.nbItems)) : get(state, 'list', 'no list')
    },

    getSearchedItems: (_state, getters) => params => {
        return filter(getters.getItems(), item => {
            return every(keys(params), field => {
                if (isNull(params[field])) {
                    return true
                } else if (isBoolean(params[field])) {
                    return item[field] === params[field]
                } else if (field === 'input') {
                    return (
                        String(item['id'])
                            .toLowerCase()
                            .indexOf(String(params.input).toLowerCase()) > -1 ||
                        String(item['label'])
                            .toLowerCase()
                            .indexOf(String(params.input).toLowerCase()) > -1
                    )
                } else if (field === 'id') {
                    return parseInt(item[field]) === parseInt(params[field])
                } else if (field === 'type') {
                    return item.type === params[field]
                } else if (field === 'status') {
                    return item[field] === params[field]
                } else if (field === 'jsonKeyName') {
                    return item.jsonKey.name === params[field]
                } else if (field === 'jsonKeyNames') {
                    return params[field].includes(item['jsonKey']['name'])
                } else if (field === 'jsonKeyType') {
                    return item.jsonKey.type === params[field]
                } else {
                    return item[field].match(params[field])
                }
            })
        })
    },

    getActiveItems: (_state, getters) => () => {
        return getters.getSearchedItems({
            status: 'active'
        })
    },

    getInactiveItems: (_state, getters) => () => {
        return getters.getSearchedItems({
            status: 'inactive'
        })
    },

    getItemById: (_state, getters) => params => {
        const item = getters.getSearchedItems({ id: params.id })
        //if more than one item has the same id => error
        if (size(item) > 1) return false
        return head(item) || null
    },

    getItemByJsonKeyName: (_state, getters) => params => {
        const item = head(getters.getSearchedItems({ jsonKeyName: params.jsonKeyName }))
        return item || null
    },

    getSearchedItemByJsonKeyName: state => params => {
        let item = null
        const dataList = get(state, 'list', [])
        if (!isEmpty(dataList)) {
            item = head(filter(dataList, item => item.jsonKey.name === params.jsonKeyName))
        }
        return item || null
    },

    /**
     * This getters is used to know if the builder criteria list can be displayed.
     * It is useful to getter 'ui/builder/criteriaListIsReady'.
     * The general rule is that the list is not ready if one of these elements is loading
     * that's why this method is from the commons getters.
     *
     * If the rule should be different for a particular module you can override this getter
     * in the context of the particular module
     *
     * @param {Object} state - vuex module state
     * @returns {Boolean}
     */
    isReadyForCriteriaList: state => () => !state.isLoading
}

export default getters
